import styled from 'styled-components';
import { colors, wrapper } from 'globalStyles';
import { media } from "utils/style-utils";

export const Wrapper = styled.div`
  .leads-page__content {
    ${wrapper}
    width: 90%;
    height: 100%;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: ${colors.MEDIUM_GRAY};
    margin: 0px auto;
    ${media.desktop`
      width: 90%;
      max-width: 100%;
    `}
  }
`;